import{PROVIDE_PRODUCT_ALTERNATIVE_LOCATION}from"../constants/ActionTypes";/**
 * @param {string} productId .
 * @param {Object} params for fetching product locations.
 * @return {Object}
 */export var provideProductAlternativeLocation=function provideProductAlternativeLocation(productId,params){return{type:PROVIDE_PRODUCT_ALTERNATIVE_LOCATION,productId:productId,params:params};};